'use client';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export function TopicList({
  topics,
  selectedTopic,
  onSelectTopic,
  layout = 'horizontal',
}) {
  const isVertical = layout === 'vertical';

  const renderTopicBadge = (topic) => {
    const isSelected = selectedTopic === (topic.name || topic.slug);
    return (
      <Badge
        key={topic.name || topic.slug}
        variant={isSelected ? 'default' : 'outline'}
        className={cn(
          "cursor-pointer transition-all duration-300 border-white/10 hover:border-violet-500/50",
          isSelected
            ? "bg-gradient-to-r from-violet-600 to-cyan-600 hover:from-violet-500 hover:to-cyan-500 border-0 text-white shadow-lg shadow-violet-500/20"
            : "bg-black/40 text-zinc-400 hover:text-white hover:bg-white/5",
          isVertical ? 'flex items-center gap-2 w-full justify-between py-2' : 'px-4 py-1.5 text-sm'
        )}
        onClick={() => onSelectTopic(topic.name || topic.slug)}
      >
        <span>{topic.name}</span>
        {topic.count > 0 && (
          <span className={cn(
            "text-xs opacity-60",
            isVertical ? 'ml-2' : 'ml-2',
            isSelected ? 'text-white' : 'text-zinc-500'
          )}>
            {topic.count}
          </span>
        )}
      </Badge>
    );
  };

  const renderAllBadge = () => {
    const isSelected = !selectedTopic;
    return (
      <Badge
        variant={isSelected ? 'default' : 'outline'}
        className={cn(
          "cursor-pointer transition-all duration-300 border-white/10 hover:border-violet-500/50",
          isSelected
            ? "bg-gradient-to-r from-violet-600 to-cyan-600 hover:from-violet-500 hover:to-cyan-500 border-0 text-white shadow-lg shadow-violet-500/20"
            : "bg-black/40 text-zinc-400 hover:text-white hover:bg-white/5",
          isVertical ? 'flex items-center gap-2 w-full justify-between py-2' : 'px-4 py-1.5 text-sm'
        )}
        onClick={() => onSelectTopic(null)}
      >
        All
      </Badge>
    );
  };

  if (isVertical) {
    return (
      <div className="flex flex-col gap-2">
        {renderAllBadge()}
        {topics.map(renderTopicBadge)}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {renderAllBadge()}
      {topics.map((topic) => renderTopicBadge(topic))}
    </div>
  );
}
